import React, { Component } from 'react'
import './styles.scss';
export default class Checkbox extends Component {
 
  constructor(props) {
    super(props);
    this.state = { checked: this.props.isChecked? this.props.isChecked : false };
  }
  handleClick = () => {

    //console.log('state',this.state.checked);

    const { callback, group, id } = this.props
    
    // this.setState(prevState => {
    //   console.log('!prevState.checked',!prevState.checked);
      
    //   return {
    //     checked: !prevState.checked
    //   }
    // })
    

    if(callback) callback(id, !this.props.isChecked, group)

    
  }
  render() {
    const { label, isChecked, id, labelAll } = this.props
    
    return (
      <div className={labelAll ? "label-all" : "select-item"} onClick={() => this.handleClick()}>
        <input id={id} className="styled-checkbox" type="radio" checked={isChecked}/>
        <label htmlFor={id}>{label}</label>
      </div>

    )
  }
}
